import styles from './index.less';
import * as React from 'react';

/**
 * 分享海报弹窗底部「复制分享链接」按钮（2026-09-20 需求：原底部左按钮的复制入口移入弹窗，
 * 样式由图素改为 CSS 绘制的白边框左右圆角按钮）。
 * 无 Store 受控展示组件：视觉归本组件，点击回调由页面 Store 注入
 * （复制编排与反馈归 EndedPosterStore.copyCurrentTarget）。
 *
 * @param {object} props
 * @param {Function} props.onClick 点击回调（复制分享链接）。
 * @returns {JSX.Element} 按钮节点。
 */
const ShareCopyFooter = ({ onClick }) => (
  <button className={styles.root} type="button" aria-label="复制分享链接" onClick={onClick}>
    复制分享链接
  </button>
);

export default ShareCopyFooter;
